export const sections = [
  'pageStart',
  'description',
  'specification',
  'documentation',
  'variants',
  'rating',
  'recommendedVariants',
] as const;

export type SectionId = (typeof sections)[number];

export const anchors = sections.reduce(
  (acc, sectionId) => ({ ...acc, [sectionId]: sectionId }),
  {} as Record<SectionId, SectionId>
);
